import { videoHotlineConstants } from './constants/videoHotlineConstants';

const videoHotlineGetDetail = (id: any) => {
	return {
		type: videoHotlineConstants.VideoHotlineDetailRequest,
		input: id
	};
};

const videoHotlineGetByfilter = (input: any) => {
	return {
		type: videoHotlineConstants.VideoHotlineGetByfilterRequest,
		input: input
	};
};

const getMessageBoardID = (id: any) => {
	return {
		type: videoHotlineConstants.GetMessageBoardIDRequest,
		input: id
	};
};

const videoHotlineDelete = (id: any) => {
	return {
		type: videoHotlineConstants.VideoHotlineDeleteRequest,
		input: id
	};

};

export const videoHotlineAction = {
	videoHotlineGetDetail,
	videoHotlineGetByfilter,
	getMessageBoardID,
	videoHotlineDelete
}